/* eslint-disable indent */
import { useAppSelector } from '../../hooks'
import { Currency } from '../../services'
import CardsWithInfo from '../CardsWithInfo/CardsWithInfo'

const Info = () => {
	const user = useAppSelector((state) => state.user)

	const currency =
		user.currency === Currency.USD
			? '$'
			: user.currency === Currency.EUR
				? '€'
				: user.currency === Currency.RUB
					? '₽'
					: '$'

	const cardData = [
		{
			title: 'WALLET',
			content: (
				<div style={{ display: 'flex', flexDirection: 'column', gap: '12px', width: '100%' }}>
					<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 0', borderBottom: '1px solid rgba(255, 255, 255, 0.1)' }}>
						<span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
							<span style={{ fontSize: '20px', flexShrink: 0 }}>💎</span>
							<span style={{
								fontWeight: '700',
								fontSize: '22px',
								background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
								WebkitBackgroundClip: 'text',
								WebkitTextFillColor: 'transparent',
								backgroundClip: 'text'
							}}>
								{user.balanceRobux || 0} R$
							</span>
						</span>
						<span style={{ color: '#9ca3af', fontSize: '16px' }}>
							my robux
						</span>
					</div>
					<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 0', borderBottom: '1px solid rgba(255, 255, 255, 0.1)' }}>
						<span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
							<span style={{ fontSize: '20px', flexShrink: 0 }}>💰</span>
							<span style={{
								fontWeight: '700',
								fontSize: '22px',
								background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
								WebkitBackgroundClip: 'text',
								WebkitTextFillColor: 'transparent',
								backgroundClip: 'text'
							}}>
								{(user.balance ?? 0).toFixed(2)}{currency}
							</span>
						</span>
						<span style={{ color: '#9ca3af', fontSize: '16px' }}>
							cash balance
						</span>
					</div>
					<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 0' }}>
						<span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
							<span style={{ fontSize: '20px', flexShrink: 0 }}>📊</span>
							<span style={{
								fontWeight: '700',
								fontSize: '18px',
								background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
								WebkitBackgroundClip: 'text',
								WebkitTextFillColor: 'transparent',
								backgroundClip: 'text',
								whiteSpace: 'nowrap'
							}}>
								1000R$ = {user.rate || 1}{currency}
							</span>
						</span>
						<span style={{ color: '#9ca3af', fontSize: '16px' }}>
							rate
						</span>
					</div>
				</div>
			),
		},
	]

	return <CardsWithInfo cardData={cardData} />
}

export default Info
